@if (document) {
  <div class="document-header">
    <div class="document-info">
      <span class="document-title">{{ document.documentId }}</span>
      <span class="document-group">{{ document.documentGroup }}</span>
    </div>
    <button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>
  </div>
  <div class="scroll-wrapper">
    <ngx-extended-pdf-viewer
      [src]="document.documentUrl!"
      [useInlineScripts]="false"
      [showBorders]="false"
      [showToolbar]="false"
      [textLayer]="false"
      [sidebarVisible]="false"
      backgroundColor="#F7F7F7"
      [zoom]="'page-fit'"
      (pageChange)="onPageChange($event)"
      (pagesLoaded)="onPagesLoaded($event)"
    >
    </ngx-extended-pdf-viewer>
  </div>
  <div class="button-container">
    @if (showClose || document.acceptance) {
      <button rktButton title="Close" class="doc-close-button" (click)="activeModal.close()">Close</button>
    }
    @if (showAccept && !document.acceptance) {
      <button rktButton title="I Accept" class="doc-close-button" [disabled]="!isScrolledToTheEnd" (click)="activeModal.close('accepted')">
        I Accept
      </button>
    }
  </div>
}
